import { Box, css, Stack, styled } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

import { Dialog } from '@/components/Dialog';
import { LayersControl } from '@/components/map/LayersControl';
import { LevelOfServiceLegend } from '@/components/map/LevelOfServiceLegend';
import { RoutingMap } from '@/components/map/RoutingMap';
import { SidebarNavigation } from '@/components/routing/SidebarNavigation';

const Root = styled(Box)(css`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: row;
  position: relative;
`);
const RoutingMapWrapper = styled(Box)(css`
  position: absolute;
  inset: 0;
`);

const SidebarWrapper = styled(Box)(
  ({ theme }) => css`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: ${theme.zIndex.drawer};
    pointer-events: none;
    display: flex;
    align-items: flex-end;

    > * {
      pointer-events: auto;
    }
  `,
);

const zValidateSearch = z.object({
  resultIndex: z.number().optional(),
  popup: z.boolean().optional(),
  id: z.union([z.string(), z.number()]).optional(),
});

export const Route = createFileRoute('/_map')({
  validateSearch: zValidateSearch,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: MapLayout,
});

function MapLayout() {
  return (
    <Root>
      <SidebarWrapper>
        <SidebarNavigation />
        <Outlet />

        <Stack alignItems="flex-end" direction="row" height="fit-content" mb={1.5} ml={1.5} spacing={1.5} zIndex={1}>
          <LayersControl />
          <LevelOfServiceLegend />
        </Stack>
      </SidebarWrapper>

      <RoutingMapWrapper>
        <RoutingMap />
      </RoutingMapWrapper>

      <Dialog />
    </Root>
  );
}
